import * as types from "./../types";

const initState = {
    payLinkData: null,
    isLoading: false,
    cookieData: null,
    accountValidation: null,
    accountValidationFailed: null,
    paybackFailed: null,
    debitRetryCount: null,
    creditRetryCount: null,
    createOrderData: null,
};

const PenyDropReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_PAY_LINK_SERVICE_DATA:
            return {
                ...state,
                payLinkData: action.payload?.data,
            };
        case types.GET_CREATE_ORDER_DATA:
            return {
                ...state,
                createOrderData: action.payload?.data,
            };
        case types.SHOW_LOADER_FOR_PENY:
            return {
                ...state,
                // isLoading: action.payload
                isLoading: action.payload.loader,
                cookieData: action.payload.cookieData
            }
        case types.ACCOUNT_VALIDATION:
            return {
                ...state,
                accountValidation: action.payload
            }
        case types.IS_ACCOUNT_VALIDATION_FAILED:
            return {
                ...state,
                accountValidationFailed: action.payload
            }
        case types.IS_PAYBACK_FAILED:
            return {
                ...state,
                paybackFailed: action.payload
            }
        case types.CREDIT_RETRY_COUNT:
            return {
                ...state,
                creditRetryCount: action.payload
            }
        case types.DEBIT_RETRY_COUNT:
            return {
                ...state,
                debitRetryCount: action.payload
            }
        default:
            return state;
    }
};

export default PenyDropReducer;
